import React from 'react'
import { ButtonRequestCP } from 'submodules/nerit-framework-ui/features/common/components/button-request/ButtonRequestCP'
import { SamplingRequests } from 'submodules/nerit-aquatec-sdk/services/samplings/SamplingRequests'

interface ICPProps {
    code: number
    onSuccess: () => void
}

export function ButtonClearFieldValuesCP(props: ICPProps): JSX.Element {
    return (
        <ButtonRequestCP
            requestConfigTP={() => SamplingRequests.deleteFieldValues(props.code)}
            onSuccess={props.onSuccess}
            appearance={{
                size: 'small',
                label: 'Limpar dados',
                icon: 'highlight',
                type: 'default',
                hideIcon: false
            }}
            messages={{
                confirmMessage: 'Tem certeza que deseja limpar todos os dados desta campanha?',
                successMessage: 'Dados limpos com sucesso!',
                errorMessage: 'Erro ao limpar os dados.'
            }}
        />
    )
} 